// react
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// context hooks
import useAsp from 'hooks/useAsp';

// types
import { OrderType } from 'types/order';

const MoshimoTag = () => {
  const { isThanks, order } = useAsp();
  const { pathname } = useLocation();

  const orderCode = order ? (order as OrderType).order_code : '';

  useEffect(() => {
    const scriptId = isThanks ? 'msmaf' : 'moshimo';
    const cvScriptId = 'ad-track-cv';
    const isExistScript = document.getElementById(scriptId);
    const isExistCvScript = document.getElementById(cvScriptId);
    if (!!isExistScript) isExistScript.remove();
    if (!!isExistCvScript) isExistCvScript.remove();

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = isThanks
      ? `https://r.moshimo.com/af/r/result.js?p_id=6658&pc_id=18999&m_v=${orderCode}`
      : 'https://r.moshimo.com/af/r/maftag.js';

    document.body.appendChild(script);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, isThanks, order]);

  return isThanks ? (
    <noscript>
      <img src={`https://r.moshimo.com/af/r/result?p_id=6658&pc_id=18999&m_v=${orderCode}`} width="1" height="1" alt="" />
    </noscript>
  ) : (
    <></>
  );
};

export default MoshimoTag;
